import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { setAuth } from '../../lib/auth';
import alamoLogo from '../../assets/alamo-logo.webp';

const API_BASE = '';

const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const text = await response.text();

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error(`Non-JSON response: ${text.slice(0, 200)}`);
      }

      setLoading(false);

      if (!response.ok) {
        setError(data.error || 'Login failed');
        return;
      }

      setAuth(data);
      navigate('/');
    } catch (err) {
      setLoading(false);
      setError(err.message || 'Unable to connect to server');
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      px={2}
      sx={{
        background: 'linear-gradient(135deg, #841C00 0%, #9B1D00 52%, #F89B2E 100%)'
      }}
    >
      <Box
        maxWidth={400}
        width="100%"
        p={4}
        boxShadow={3}
        borderRadius={2}
        bgcolor="background.paper"
      >
        <Box textAlign="center" mb={3}>
          <Box
            component="img"
            src={alamoLogo}
            alt="Alamo Center"
            sx={{
              width: '100%',
              maxWidth: 280,
              height: 'auto',
              objectFit: 'contain'
            }}
          />
        </Box>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Sign In
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleLogin}>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            required
            margin="normal"
          />

          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            required
            margin="normal"
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
            sx={{ mt: 2 }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default LoginPage;